<!-- Only render if isOpen is true -->
@if (state().isOpen) {
	<div
		class="modal-overlay"
		(click)="onOverlayClick($event)"
		>
		<!-- Hidden focus trap to prevent inputs from stealing focus -->
		<div tabindex="0" #focusTrap style="position: absolute; width: 0; height: 0; opacity: 0;"></div>
		<!-- Stop click propagation so clicking inside the box doesn't close it -->
		<div
			class="modal-content v2"
			(click)="$event.stopPropagation()"
			*transloco="let t"
			>
			@if (state().config.closable) {
				<button class="close-btn" (click)="close()">×</button>
			}
			<div class="modal-title">
				@if (isString(state().content.title)) {
					{{ state().translate ? t(state().content.title | asType:'string') : state().content.title }}
				} @else {
					<ng-container
						[ngTemplateOutlet]="asTemplate(state().content.title)"
						[ngTemplateOutletContext]="{ $implicit: state().context }">
					</ng-container>
				}
			</div>
			<div class="modal-body">
				@if (isString(state().content.body)) {
					{{ state().translate ? t(state().content.body | asType:'string') : state().content.body }}
				} @else {
					<ng-container
						[ngTemplateOutlet]="asTemplate(state().content.body)"
						[ngTemplateOutletContext]="{ $implicit: state().context }">
					</ng-container>
				}
			</div>
		</div>
	</div>
}
